import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DadosProvider } from '../../providers/dados/dados';

@Component({
  selector: 'page-mensagem-list',
  templateUrl: 'mensagem-list.html',
})
export class MensagemListPage {

  mensagens:Array<any>;

  constructor(public navCtrl: NavController, public navParams: NavParams, private dadosP:DadosProvider) {
    this.mensagens = [];
    this.carregarMensagens();
  }

  carregarMensagens(){

    this.dadosP.carregarMenagens().subscribe(
      (dados) => {
          this.mensagens = dados;
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/mensagem-list/mensagem-list.ts